export class CalenderWeek {
  public constructor(
    weekNumber: number,
    isActive: boolean,
    input: number,
    output: number
  ) {
    this.weekNumber = weekNumber;
    this.isActive = isActive;
    this.input = input;
    this.output = output;
  }
  
  public weekNumber: number;
  public isActive: boolean;
  public input: number;
  public output: number;
}
